import React from 'react';
import {DiscoveryWizard} from "../discovery";

export { Dashboard };

function Dashboard() {

    return (
            <DiscoveryWizard />
    );
}
